<template>
  <div>
    <a data-toggle="collapse" :href="`#picker_${this._uid}`">
      <div class="row">
        <label style="top: 0px" class="align-middle small font-weight-bold bmd-label-static col">
          {{ Label }}
        </label>
        <div class="col-4" :style="colorPreview" />
        <i class="col-2 fas fa-angle-down" />
      </div>
    </a>
    <div class="collapse mt-3 text-center" :id="`picker_${this._uid}`">
      <div class="row d-flex justify-content-center">
        <slot />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'InputColorPicker',
  props: {
    model: { type: Object, default: () => ({}) },
    Label: { type: String, default: '' },
  },
  computed: {
    colorPreview() {
      return {
        backgroundColor: this.model.hex,
      };
    },
  },
};
</script>

<style scoped></style>
